import { localStorageKeys } from '@/registry/local-storage-keys'

export type ContactLensImageType = 'worn' | 'lens' | 'package'

export const DEFAULT_IMAGE_TYPE: ContactLensImageType = 'package'

const STORAGE_KEY = localStorageKeys.contactLensImageType

const HINT_DISMISSED_KEY = localStorageKeys.contactLensImageTypeSwitcherHintDismissed

/**
 * カラコン商品一覧の画像種別のlocalStorage永続化。
 *
 * 既存の商品一覧(Vuex module: store/modules/contactLensImageType)とホテラバ専用商品一覧の
 * 両方から使われる。同じキーを共有することで、どちらの一覧で切り替えても
 * 「最後に選んだ画像種別」が引き継がれる。
 */
export function loadContactLensImageType(): ContactLensImageType {
  try {
    const value = localStorage.getItem(STORAGE_KEY)

    // 予期しない値が入っている場合はデフォルトのパッケージ画にフォールバック
    return (value === 'worn' || value === 'lens' || value === 'package') ? value : DEFAULT_IMAGE_TYPE
  } catch {
    // localStorage が利用不可の場合はデフォルトのパッケージ画にフォールバック
    return DEFAULT_IMAGE_TYPE
  }
}

export function saveContactLensImageType(type: ContactLensImageType): void {
  try {
    localStorage.setItem(STORAGE_KEY, type)
  } catch {
    // localStorage が利用不可の場合は無視
  }
}

/**
 * 画像種別切替ボタンの初回ヒント(吹き出し)を確認済みかのlocalStorage永続化。
 * 画像種別と同じく既存の商品一覧とホテラバ専用商品一覧でキーを共有し、
 * どちらかの一覧で一度切り替えを操作した人にはどちらの一覧でもヒントを出さない。
 */
export function loadContactLensImageTypeSwitcherHintDismissed(): boolean {
  try {
    return localStorage.getItem(HINT_DISMISSED_KEY) === '1'
  } catch {
    // localStorage が利用不可の場合は確認済み扱いにする(フラグを保存できず、訪問のたびにヒントを出し続けてしまうため)
    return true
  }
}

export function saveContactLensImageTypeSwitcherHintDismissed(): void {
  try {
    localStorage.setItem(HINT_DISMISSED_KEY, '1')
  } catch {
    // localStorage が利用不可の場合は無視
  }
}
